import { render, staticRenderFns } from "./price-text.vue?vue&type=template&id=7d444ce4&"
import script from "./price-text.vue?vue&type=script&lang=js&"
export * from "./price-text.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports